"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_deferred_1 = require("ts-deferred");
const _1 = require(".");
/**
 * Represents a source which produces cancellation tokens. The source can then
 * be used to trigger the associated cancellation token(s).
 */
class CancellationTokenSource {
    /**
     * Creates a cancellation token source. If a deferred or promise is
     * provided, then the cancellation token source will cancel all linked
     * tokens when the deferred or promise resolves. If a number is provided,
     * then the cancellation token source will cancel all linked tokens after
     * that many milliseconds have elapsed. If future is undefined, then the
     * cancellation token source will not cancel the linked tokens until the
     * `cancel` method of the source is called.
     * @param future
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(future) {
        this._cancelled = false;
        /**
         * requests cancellation of the issued tokens.
         */
        this.cancel = () => {
            // istanbul ignore else
            if (!this._cancelled) {
                this._cancelled = true;
                this._cancellationFuture.resolve();
            }
        };
        if (typeof future === 'number') {
            this._cancellationFuture = new ts_deferred_1.Deferred();
            const timeout = setTimeout(() => {
                this._cancellationFuture.resolve();
            }, future);
            this._cancellationFuture.promise.then(() => {
                clearTimeout(timeout);
            });
        }
        else if (future instanceof ts_deferred_1.Deferred) {
            this._cancellationFuture = future;
        }
        else if (future instanceof Promise) {
            this._cancellationFuture = new ts_deferred_1.Deferred();
            future.then(() => this._cancellationFuture.resolve());
        }
        else {
            this._cancellationFuture = new ts_deferred_1.Deferred();
        }
        this._cancellationFuture.promise.then(() => this._cancelled = true);
    }
    /**
     * Returns a new cancellation token linked to this source. If the source is
     * in a cancelled state when the token is created, the token will also be
     * in the cancalled state.
     */
    get token() {
        return new _1.CancellationToken(this._cancellationFuture);
    }
    /**
     * Returns true if the cancellation token source has been cancelled.
     */
    get isCancellationRequested() {
        return this._cancelled;
    }
    /**
     * Creates a cancellation token source which cancels when any of the linked
     * sources cancel.
     *
     * @param tokens
     * @returns
     */
    static createLinkedTokenSource(...tokens) {
        const future = new ts_deferred_1.Deferred();
        Promise
            .race(tokens.map(token => {
            if (token instanceof CancellationTokenSource) {
                return token.token.waitHandle;
            }
            else if (token instanceof _1.CancellationToken) {
                return token.waitHandle;
            }
            else if (token instanceof _1.Task) {
                return token.waitHandle;
            }
            else {
                return new CancellationTokenSource(token).token.waitHandle;
            }
        }))
            .then(future.resolve, future.reject);
        const cts = new CancellationTokenSource(future);
        return cts;
    }
}
exports.default = CancellationTokenSource;
//# sourceMappingURL=cancellationTokenSource.js.map